<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "commissions-index",
  mounted () {
    /* 
      Recupera infos do afiliado, gerenciar visualização das views
      de CPA
    */
    this.getAffiliate();
  },
  methods: {
    getAffiliate() {
      this.$axios
        .get("/agent/affiliates/getAffiliate")
        .then((response) => {
          let cpaType = response.data.dados.cpa_tipo;
          this.$store.commit("setAffiliateCpaType", cpaType);
        })
        .catch(() => {});
    }
  }
}
</script>